<div class="lv-inline-fehlermeldung">
  <div class="lv-inline-fehlermeldung-icon">
    <mat-icon color="accent" [svgIcon]="'Stop'"></mat-icon>
  </div>
  <div [innerHTML]="fehlermeldung"></div>
</div>
